import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "./filter_tab.css";
import { activeTab, availableRuns, changeTab, statisticsOptions } from "../../../stores/statistics.store";
import { isMobile } from "../../../App";

interface FilterTabProps {
  results: any;
  selectedHippodrome: any;
}

const FilterTab: React.FC<FilterTabProps> = ({ results, selectedHippodrome }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabRefs = useRef<{ [key: string]: HTMLLIElement | null }>({});
  const navContainerRef = useRef<HTMLUListElement | null>(null);
  const [tabList, setTabList] = useState<any[]>([]);

  useEffect(() => {
    if (results) {
      if (selectedHippodrome.is_foreign) {
        setTabList([
          { key: "previous-runs", value: "son-kosular", label: "Son Koşular", path: "/son-kosular" },
          { key: "previous-wins", value: "birincilikler", label: "Birincilikler", path: "/birincilikler" },
          {
            key: "who-run-with-whom",
            value: "kim-kiminle-kostu",
            label: "Kim Kiminle Koştu",
            path: "/kim-kiminle-kostu",
          },
        ]);
      } else {
        setTabList([
          { key: "gallops", value: "galoplar-sprintler", label: "Galoplar/Sprintler", path: "/galoplar-sprintler" },
          { key: "best-degree", value: "en-iyi-dereceler", label: "En İyi Dereceler", path: "/en-iyi-dereceler" },
          { key: "previous-runs", value: "son-kosular", label: "Son Koşular", path: "/son-kosular" },
          { key: "previous-wins", value: "birincilikler", label: "Birincilikler", path: "/birincilikler" },
          {
            key: "who-run-with-whom",
            value: "kim-kiminle-kostu",
            label: "Kim Kiminle Koştu",
            path: "/kim-kiminle-kostu",
          },
        ]);
      }
    }
  }, [selectedHippodrome, results]);

  useEffect(() => {
    if (tabList.length > 0) {
      if (location.pathname !== "/") {
        changeTab(tabList.find((item: any) => `/${item.value}` === location.pathname));
      } else {
        navigate(tabList[0].path);
        changeTab(tabList[0]);
      }
    }

    if (availableRuns && statisticsOptions.selectedHippodrome) {
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set("hipodrom", statisticsOptions.selectedHippodrome.tjk_key.toLowerCase());
      // eslint-disable-next-line no-restricted-globals
      history.replaceState(null, "", window.location.pathname + "?" + queryParams.toString());
    }
  }, [tabList]);

  const handleTabClick = (tab: any) => {
    if (tab.path !== location.pathname) {
      changeTab(tab);
      navigate(tab.path);
    }
    if (isMobile) {
      const tabElement = tabRefs.current[tab.key];
      const navContainer = navContainerRef.current;
      if (tabElement && navContainer) {
        const tabOffsetLeft = tabElement.offsetLeft;
        const tabWidth = tabElement.clientWidth;
        const containerWidth = navContainer.clientWidth;
        const scrollPosition = tabOffsetLeft - containerWidth / 2 + tabWidth / 2;
        navContainer.scrollTo({ left: scrollPosition, behavior: "smooth" });
      }
    }

    if (availableRuns && statisticsOptions.selectedHippodrome) {
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set("hipodrom", statisticsOptions.selectedHippodrome.tjk_key.toLowerCase());
      // eslint-disable-next-line no-restricted-globals
      history.replaceState(null, "", window.location.pathname + "?" + queryParams.toString());
    }
  };

  const handleArrowClick = (direction: "left" | "right") => {
    const currentIndex = tabList.findIndex((tab) => tab.key === activeTab.key);
    let newIndex = direction === "left" ? currentIndex - 1 : currentIndex + 1;
    if (newIndex < 0) newIndex = tabList.length - 1;
    if (newIndex >= tabList.length) newIndex = 0;
    const newTab = tabList[newIndex];
    handleTabClick(newTab);
  };

  return (
    <div className="filter-tab-container row mx-lg-2">
      {isMobile && (
        <div className="tab-navigation col-1" onClick={() => handleArrowClick("left")}>
          <IoIosArrowBack />
        </div>
      )}
      <ul ref={navContainerRef} className="filters col-10">
        {tabList.map((tab: any, index: number) => (
          <li className="filter-item" key={`tab-${index}`} ref={(el) => (tabRefs.current[tab.key] = el)}>
            <a
              className={`filter-link ${activeTab?.key === tab.key ? "active" : ""}`}
              onClick={() => handleTabClick(tab)}
            >
              {tab.label}
            </a>
          </li>
        ))}
      </ul>
      {isMobile && (
        <div className="tab-navigation col-1" onClick={() => handleArrowClick("right")}>
          <IoIosArrowForward />
        </div>
      )}
    </div>
  );
};

export default FilterTab;
